import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import type { ComponentSlotStyleFunction } from '@fluentui/styles';

export const MOBILE_INPUT_BG = '#EEE';
export const INPUT_ERROR_COLOR = '#E5505C';

export const ModalHeader: ComponentSlotStyleFunction = () => ({
    margin: pxArrayToRem([28, 15, 24]),
});

export const ModalClose: StyleRule = () => ({
    pointer: 'cursor',
    width: pxToRem(16),
    height: pxToRem(16),
});

export const ModalTitle: StyleRule = () => ({
    marginLeft: pxToRem(66),
});

export const ModalContent: StyleRule = () => ({
    borderTop: 0,
    padding: pxArrayToRem([0, 18, 20, 18]),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    margin: 0,
});

export const MainContent: StyleRule = () => ({
    flex: 1,
});

export const CollaboratorsList: StyleRule = () => ({
    listStyle: 'none',
    padding: 0,
    margin: pxArrayToRem([0, 3, 0, 1]),
});

export const CollaboratorsListItem: StyleRule = ({ theme }) => ({
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(20),
    height: pxToRem(70),
    marginBottom: pxToRem(2),
    width: '100%',
    borderBottom: `1px solid ${theme.siteVariables.colors.grey['100']}`,
});

export const ExtraAction: StyleRule = () => ({
    marginTop: pxToRem(34),
});

export const Avatar: StyleRule = () => ({
    position: 'relative',
    '& svg': {
        height: pxToRem(36),
        width: pxToRem(36),
        left: pxToRem(6),
        top: pxToRem(4),
        position: 'absolute',
    },
});

export const InviteCollaborator: StyleRule = () => ({
    fontSize: pxToRem(16),
    paddingLeft: pxToRem(10),
});

export const CloseButton: StyleRule = () => ({
    textTransform: 'uppercase',
    width: '100%',
    alignSelf: 'flex-end',
    height: pxToRem(50),
});
